import * as React from 'react';
import getField, { Field } from '../ComposableTableField';
import Icon from 'components/Icon';
import MediaObject from 'components/MediaObject';

type EditCellProps<T> = {
  onEdit: (data: T) => any;
};

export function EditCell<T>(props: EditCellProps<T> & { field: T; content: string }) {
  const onEditClick = () => props?.onEdit(props.field);

  return (
    <div onClick={onEditClick}>
      <MediaObject className="ComposableTable-editCell" center gutter="small">
        {props.content}
        <Icon name="pencil-stroke-square" color="wolf" />
      </MediaObject>
    </div>
  );
}

export function getEditCellGenerator<T>(field: Field<T>, editCellProps: EditCellProps<T>) {
  return (data: T) => {
    const fieldValue = getField(data, field);

    return <EditCell {...editCellProps} field={data} content={fieldValue} />;
  };
}
